import soundIcon from "../assets/products/windows/sound_Insulation.png";
import waterIcon from "../assets/products/windows/water_Tightness.png";
import windIcon from "../assets/products/windows/wind_Load.png";
import colorIcon from "../assets/products/windows/color_Choice.png";
import impactIcon from "../assets/products/windows/impact_Resistance.png";
import warrantyIcon from "../assets/products/windows/years_Warranty.png";
import {
  HL_2560_SLIM_PARTITION,
  HL_40_CASEMENT_DOOR_1,
  HL_40_CASEMENT_DOOR_2,
  HL_50_CASEMENT_DOOR_1,
  HL_50_CASEMENT_DOOR_2,
  HL_ECO_GULF_SYSTEM_1,
  HL_ECO_GULF_SYSTEM_2,
  HL_ELITE_1,
  HL_ELITE_2,
  HL_IMPERIAL_MINIMAL_SYSTEM_1,
  HL_RETRO_GULF_SYSTEM_1,
  HL_RETRO_GULF_SYSTEM_2,
  HL_ULTRA_MINIMAL_1,
  HL_ULTRA_MINIMAL_2,
  HL_ULTRA_MINIMAL_3,
  HL_ULTRA_MINIMAL_4,
  HL_VISTA_MINIMAL_SYSTEM_1,
  HL_VISTA_MINIMAL_SYSTEM_2,
  LINEAR_100C,
  LINEAR_84C,
  LINEAR_84R_1,
  LINEAR_84R_2,
  OPEN_CELL,
  ROUND_BUFFULE,
  SUN_lOUVERS,
  U_SHAPE,
  V_SHAPE_1,
  V_SHAPE_2,
  V_SHAPE_3,
  V_SHAPE_4,
} from "../utilis/products";

export const PRODUCTS_DATA = {
  "windows-doors": {
    title: "Windows & Doors",
    subcategories: {
      "HL Imperial Slim System": {
        subTitle:
          "The Zenith of Design: Imperial Slim Sliding Windows with Invisible Frames",
        description: `
Step into a realm of unparalleled luxury and architectural marvel with HL Imperial Slim Sliding Windows.
This system redefines panoramic living with concealed frames for an uninterrupted expanse of glass.
  `,
        thumbnail: HL_IMPERIAL_MINIMAL_SYSTEM_1,
        images: [HL_IMPERIAL_MINIMAL_SYSTEM_1],
        specs: {
          "Track Frame Width": "164 MM",
          "Track Frame Height": "68 MM",
          "Interlock Sightline": "17 MM",
          "Glass Thickness": "20 MM to 38 MM",
          "Max Shutter Height": "6000 MM",
          "Max Shutter Width": "3500 MM",
          "Locking Type": "Multi Locking (Top-Bottom)",
          "Mosquito Net": "Integrated Pleated",
          "Roller Capacity": "Up to 500 kg",
          "Wind Load Capacity": "3.8 KPA",
        },
        features: baseFeatures(),

        variants: {
          SS2: {
            title: "HL Imperial Slim System - SS2",
            subTitle: "All-Way Concealed Frame Option (OP2)",
            description: `
The All-Way Concealed Frame Option for HL Imperial Slim System redefines minimalist design,
creating a stunning frameless opening with the illusion of uninterrupted glass that slides into a pocket.
      `,
            images: ["", ""],
            specs: {
              "Track Frame Width": "225 MM",
              "Track Frame Height": "102 MM",
              "Interlock Sightline": "17 MM",
              "Glass Thickness": "20 MM to 38 MM",
              "Max Shutter Height": "6000 MM",
              "Max Shutter Width": "3500 MM",
              "Locking Type": "Multi Locking (Top-Bottom)",
              "Mosquito Net": "NO",
              "Roller Capacity": "Up to 500 kg",
            },
          },
          SS3: {
            title: "HL Imperial Slim System - SS3",
            subTitle: "One-Side Concealed Sliding Door (OP3)",
            description: `
HL Imperial SS3 offers a seamless floating panel illusion with one-side concealed tracks for minimal aesthetic.
Ideal for large luxury openings maximizing light and elegance.
      `,
            images: ["", ""],
            specs: {
              "Track Frame Width": "164 MM",
              "Track Frame Height": "68 MM",
              "Interlock Sightline": "17 MM",
              "Glass Thickness": "20 MM to 38 MM",
              "Max Shutter Height": "6000 MM",
              "Max Shutter Width": "3500 MM",
              "Locking Type": "Multi Locking (Top-Bottom)",
              "Mosquito Net": "NO",
              "Roller Capacity": "Up to 500 kg",
            },
          },
        },
      },

      "HL Vista Slim System": {
        subTitle:
          "HL Vista Slim: Where Architectural Vision Meets Uncompromising Luxury",
        description: `
Vista Slim offers precision-engineered frames with slim sightlines that blend indoor comfort with grand outdoor views.
Crafted for elite clientele demanding transparency, elegance, and durability.
        `,
        thumbnail: HL_VISTA_MINIMAL_SYSTEM_1,
        images: [HL_VISTA_MINIMAL_SYSTEM_1, HL_VISTA_MINIMAL_SYSTEM_2],
        specs: {
          "2 Track Frame Width": "150 MM",
          "3 Track Frame Width": "217 MM",
          "Track Frame Height": "31 MM",
          "Interlock Sightline": "17 MM",
          "Glass Thickness": "12 MM to 32 MM",
          "Max Shutter Height": "4500 MM",
          "Max Shutter Width": "3000 MM",
          "Locking Type": "Multi Locking (Top-Bottom)",
          "Mosquito Net": "Pleated",
          "Roller Capacity": "Up to 300 kg",
          "Wind Load Capacity": "2.8 KPA",
        },
        features: baseFeatures(),
      },

      "HL Elite Gulf Slim System": {
        subTitle: "Unyielding Strength, Uninterrupted Views",
        description: `
Engineered for exceptional durability, HL Elite Gulf Slim System stands strong against challenging environments,
offering heavy-duty construction without compromising slim aesthetics.
        `,
        thumbnail: HL_ELITE_1,
        images: [HL_ELITE_1, HL_ELITE_2],
        specs: {
          "2 Track Frame Width": "108 MM",
          "3 Track Frame Width": "161 MM",
          "Frame Height": "41 MM",
          "Interlock Sightline": "21 MM",
          "Glass Thickness": "10 MM to 28 MM",
          "Max Shutter Height": "4000 MM",
          "Max Shutter Width": "2100 MM",
          "Locking Type": "Single / Multi Point Locking",
          "Mosquito Net": "Shutter / Pleated",
          "Roller Capacity": "Up to 250 kg",
          "Wind Load Capacity": "2.8 KPA",
        },
        features: baseFeatures(),
      },

      "HL Ultra Slim System": {
        subTitle: "Redefining Transparency: Our Ultra Slim System",
        description: `
Featuring incredibly narrow profiles, HL Ultra Slim System delivers pure uninterrupted glass views for
modern homes and contemporary architecture.
        `,
        thumbnail: HL_ULTRA_MINIMAL_1,
        images: [
          HL_ULTRA_MINIMAL_1,
          HL_ULTRA_MINIMAL_2,
          HL_ULTRA_MINIMAL_3,
          HL_ULTRA_MINIMAL_4,
        ],
        specs: {
          "2 Track Frame Width": "118 MM",
          "3 Track Frame Width": "173 MM",
          "Frame Height": "28 MM",
          "Interlock Sightline": "19 MM",
          "Glass Thickness": "5 MM to 20 MM",
          "Max Shutter Height": "3600 MM",
          "Max Shutter Width": "2000 MM",
          "Locking Type": "Multi Locking (Top-Bottom)",
          "Mosquito Net": "Pleated",
          "Roller Capacity": "Up to 250 kg",
          "Wind Load Capacity": "2 KPA",
        },
        features: baseFeatures(),
      },

      "HL Retro Gulf Slim System": {
        subTitle: "Embrace Timeless Charm with HL Retro Gulf System",
        description: `
Retro Gulf System blends vintage Gulf-style charm with modern slim profiles,
offering durability and low-maintenance performance with nostalgic beauty.
        `,
        thumbnail: HL_RETRO_GULF_SYSTEM_1,
        images: [HL_RETRO_GULF_SYSTEM_1, HL_RETRO_GULF_SYSTEM_2],
        specs: {
          "2 Track Frame Width": "100 MM",
          "3 Track Frame Width": "150 MM",
          "Frame Height": "41 MM",
          "Interlock Sightline": "25 MM",
          "Glass Thickness": "5 MM to 23 MM",
          "Max Shutter Height": "3500 MM",
          "Max Shutter Width": "2000 MM",
          "Locking Type": "Single / Multi Point Locking",
          "Mosquito Net": "Shutter / Pleated",
          "Roller Capacity": "Up to 120 kg",
          "Wind Load Capacity": "1.8 KPA",
        },
        features: baseFeatures(),
      },

      "HL Eco Gulf Slim System": {
        subTitle: "Affordable Luxury with HL Eco Gulf System",
        description: `
Eco Gulf System combines sleek aesthetics with affordability — ideal for modern homes,
delivering minimalist looks and long-lasting reliability.
        `,
        thumbnail: HL_ECO_GULF_SYSTEM_1,
        images: [HL_ECO_GULF_SYSTEM_1, HL_ECO_GULF_SYSTEM_2],
        specs: {
          "2 Track Frame Width": "83 MM",
          "3 Track Frame Width": "120 MM",
          "Frame Height": "41 MM",
          "Interlock Sightline": "19 MM",
          "Glass Thickness": "5 MM to 11.5 MM",
          "Max Shutter Height": "2100 MM",
          "Max Shutter Width": "1200 MM",
          "Locking Type": "Single / Multi Point Locking",
          "Mosquito Net": "Shutter / Pleated",
          "Roller Capacity": "Up to 80 kg",
          "Wind Load Capacity": "0.8 KPA",
        },
        features: baseFeatures(),
      },

      "HL Sliding Folding System": {
        subTitle: "Affordable Luxury with HL Eco Gulf System",
        description: `
Eco Gulf System combines sleek aesthetics with affordability — ideal for modern homes,
delivering minimalist looks and long-lasting reliability.
        `,
        thumbnail: "",
        images: [""],
        specs: {
          "2 Track Frame Width": "83 MM",
          "3 Track Frame Width": "120 MM",
          "Frame Height": "41 MM",
          "Interlock Sightline": "19 MM",
          "Glass Thickness": "5 MM to 11.5 MM",
          "Max Shutter Height": "2100 MM",
          "Max Shutter Width": "1200 MM",
          "Locking Type": "Single / Multi Point Locking",
          "Mosquito Net": "Shutter / Pleated",
          "Roller Capacity": "Up to 80 kg",
          "Wind Load Capacity": "0.8 KPA",
        },
        features: baseFeatures(),
      },

      "HL 50 Casement Door": {
        subTitle: "Grand Openings, Unyielding Performance",
        description: `
HL 50 Casement Door transforms door openings into bold architectural statements combining
strength, airtight sealing, and seamless operation.
        `,
        thumbnail: HL_50_CASEMENT_DOOR_1,
        images: [HL_50_CASEMENT_DOOR_1, HL_50_CASEMENT_DOOR_2],
        specs: {
          "Frame Width": "50 MM",
          "Frame Height": "46 MM",
          "Glass Thickness": "5 MM to 38 MM",
          "Max Shutter Height": "2500 MM",
          "Max Shutter Width": "1350 MM",
          "Locking Type": "Multi / Single",
        },
        features: baseFeatures(),
      },

      "HL 40 Casement Window": {
        subTitle: "Smart Solutions for Compact Spaces",
        description: `
HL 40 Casement Window provides ventilation and natural light in compact modern spaces,
combining light-weight design with strength and easy operation.
        `,
        thumbnail: HL_40_CASEMENT_DOOR_1,
        images: [HL_40_CASEMENT_DOOR_1, HL_40_CASEMENT_DOOR_2],
        specs: {
          "Frame Width": "40 MM",
          "Frame Height": "39 MM",
          "Glass Thickness": "4 MM to 24 MM",
          "Max Shutter Height": "1900 MM",
          "Max Shutter Width": "700 MM",
          "Locking Type": "Multi / Single",
        },
        features: baseFeatures(),
      },

      "HL 2560 Partition System": {
        subTitle: "Versatile Partition System for Interior Spaces",
        description: `
HL 2560 Partition System offers elegant separation for offices and interior spaces,
featuring glazed or aluminum/wood panels with easy assembly.
        `,
        thumbnail: HL_2560_SLIM_PARTITION,
        images: [HL_2560_SLIM_PARTITION],
        specs: {
          "Frame Width": "60 MM",
          "Frame Height": "25 MM",
          "Glass Thickness": "5 MM to 22 MM",
          "Door Sash": "55 MM x 55 MM",
        },
        features: baseFeatures(),
      },
    },
  },
  "louvers-system": {
    title: "Louvers & Ceiling Systems",
    subcategories: {
      "Linear 64C / 84C / 184C": {
        subTitle: "Closed Groove Linear Ceiling System",
        description: `
84C is 84mm wide box-shaped panel with 16mm closed groove that enhances the linear appearance of the ceiling.
Panels are demountable, allowing access to services and equipment.
      `,
        thumbnail: LINEAR_84C,
        images: [LINEAR_84C],
        specs: {
          Material: "Aluminium / Galvanized Iron (GI)",
          Panels: "64/84/184 wide, 13mm deep, length up to 5m",
          Carrier: "25mm wide, 45mm deep, 0.5mm GI steel",
          "Surface Finishing": "60–70 microns thick powder coating",
          "Installation Hardware":
            "Height Adjustment Spring Steel Clip, GS Rod, Panel Coupler",
        },
      },

      "Linear 64R / 84R / 184R": {
        subTitle: "Rounded Groove Linear Ceiling System",
        description: `
84R panels create a sleek linear ceiling with rounded grooves.
Easily demountable for access to equipment, suitable for corporate and hospitality interiors.
      `,
        thumbnail: LINEAR_84R_1,
        images: [LINEAR_84R_1, LINEAR_84R_2],
        specs: {
          Material: "Aluminium / Galvanized Iron (GI)",
          Panels: "64/84/184R wide, 13mm deep, length up to 5m",
          Carrier: "25mm wide, 45mm deep, 0.5mm GI steel",
          "Surface Finishing": "60–70 microns thick powder coating",
        },
      },

      "Linear 100C / 150C / 200C": {
        subTitle: "Wide Box-Shaped Linear Ceiling",
        description: `
Panels with V-shaped closed grooves enhance linear appearance and directionality in the ceiling.
Ideal for airports, transport hubs, and retail interiors.
      `,
        thumbnail: LINEAR_100C,
        images: [LINEAR_100C],
        specs: {
          Material: "Aluminium / Galvanized Iron (GI)",
          Panels: "100/150/200 wide, 13mm deep, up to 5m",
          Carrier: "25mm wide, 45mm deep, 0.5mm GI steel",
          "Surface Finishing": "60–70 microns thick powder coating",
        },
      },

      "U Shape Baffles": {
        subTitle: "Customizable Depth & Width Baffles",
        description: `
U-shaped panels offer flexible combinations with up to 6 different panel widths.
Can be installed horizontally or vertically for architectural freedom.
      `,
        thumbnail: U_SHAPE,
        images: [U_SHAPE],
        specs: {
          Material: "Aluminium / Galvanized Iron (GI)",
          Panels: "Customized width and height, up to 5m",
          Carrier: "Gap options 25/50/75/100mm, GI 0.5mm thick",
          "Surface Finishing": "60–70 microns thick powder coating",
        },
      },

      "V Shape Baffles": {
        subTitle: "Decorative V-Shaped Ceiling Panels",
        description: `
V-shaped baffles provide distinctive decorative ceiling patterns with strong visual rhythm.
Commonly used in public spaces, malls, and airports.
      `,
        thumbnail: V_SHAPE_1,
        images: [V_SHAPE_1, V_SHAPE_2, V_SHAPE_3, V_SHAPE_4],
        specs: {
          Material: "Aluminium / Galvanized Iron (GI)",
          Panels: "Length up to 5m",
          Carrier: "Various gaps 25/50/75/100mm, GI 0.5mm",
          "Surface Finishing": "60–70 microns thick powder coating",
        },
      },

      "Round Baffles": {
        subTitle: "Cylindrical Round Baffle System",
        description: `
Circular baffles with 50mm diameter create soft linear aesthetics and acoustic balance.
Easy maintenance and installation for modern public areas.
      `,
        thumbnail: ROUND_BUFFULE,
        images: [ROUND_BUFFULE],
        specs: {
          Material: "Aluminium",
          Panels: "Length up to 5m",
          Carrier: "25/50/75/100mm gaps, GI 0.5mm",
          "Surface Finishing": "60–70 microns thick powder coating",
        },
      },

      "Open Cell Ceiling System": {
        subTitle: "Grid-Style Open Cell Panels",
        description: `
Open cell ceiling combines aesthetics with function—ideal for fire, air conditioning,
and lighting integration while maintaining open grid appearance.
      `,
        thumbnail: OPEN_CELL,
        images: [OPEN_CELL],
        specs: {
          Material: "Aluminium / Galvanized Iron (GI)",
          Panels: "Panel length up to 2.5m",
          "Surface Finishing": "60–70 microns thick powder coating",
        },
      },

      "Sun Louvers": {
        subTitle: "Exterior Sun Control Louvers",
        description: `
Sun Louvers enhance building façades with functional sun shading.
Available in multiple angles and carrier types for architectural flexibility.
      `,
        thumbnail: SUN_lOUVERS,
        images: [SUN_lOUVERS],
        specs: {
          Material: "Aluminium / Galvanized Iron (GI)",
          Panels: "84mm wide, 5m length",
          Carrier: "Galvanized steel SL-3, SL-4, SL-5",
          "Surface Finishing": "60–70 microns thick powder coating",
        },
      },
    },
  },

  railings: {
    title: "Railing Systems",
    subcategories: {
      "ERT01-Handrail": {
        description:
          "A premium aluminium handrail designed for modern balconies and staircases, offering durability with sleek aesthetics.",
        images: [""],
      },
      "ERT02-Handrail": {
        description:
          "Contemporary handrail system with soft edges and strong grip, perfect for indoor and outdoor installations.",
        images: [""],
      },
      "ERT03-Handrail": {
        description:
          "Anodized aluminium handrail with minimal profile design — ideal for glass and SS railing combinations.",
        images: [""],
      },
      "ERT04-Handrail": {
        description:
          "Rounded handrail with anti-slip texture, combining safety and elegance for premium railing systems.",
        images: [""],
      },
      "ERT05-Handrail": {
        description:
          "Lightweight yet sturdy handrail profile, designed for modern residential and commercial spaces.",
        images: [""],
      },
      "ERT06-Handrail": {
        description:
          "Heavy-duty aluminium handrail with sleek finish, providing excellent corrosion resistance in outdoor use.",
        images: [""],
      },
      "ERB01-Bottomrail": {
        description:
          "Clean and flat aluminium bottomrail for frameless glass railing systems, ensuring maximum transparency.",
        images: [""],
      },
      "ERB02-Bottomrail": {
        description:
          "Compact bottomrail with water-drain slots and hidden anchoring system for seamless glass railing setup.",
        images: [""],
      },
      "ERB03-Bottomrail": {
        description:
          "Anodized bottomrail with reinforced channel section for long-span railing applications.",
        images: [""],
      },
      "ERB04-Bottomrail": {
        description:
          "Low-profile bottomrail ideal for balcony glass fixings, combining strength and a minimalist look.",
        images: [""],
      },
      "ERB05-Bottomrail": {
        description:
          "Architectural bottomrail with integrated drainage and alignment grooves for precision installation.",
        images: [""],
      },
      "ERB06-Bottomrail": {
        description:
          "Heavy-section base rail for structural glazing and frameless railing systems, built for high load capacity.",
        images: [""],
      },
    },
  },
};

export function baseFeatures() {
  return [
    { icon: soundIcon, label: "Sound Insulation" },
    { icon: waterIcon, label: "Water Tightness" },
    { icon: windIcon, label: "Wind Load" },
    { icon: colorIcon, label: "Color Choice" },
    { icon: impactIcon, label: "Impact Resistance" },
    { icon: warrantyIcon, label: "2 years Warranty" },
  ];
}
